import React from 'react';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets//Core';
import { Field, TextOutput } from 'Components/Core';

let BsEnIsoLiquidLimitAverageValuesSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  return (
    <SectionGroup heading="Average Values">
      <ListFieldSection>
        <Field input={<TextOutput />} name="LiquidLimitPenetration" />
        <Field input={<TextOutput />} name="WaterContent" />
      </ListFieldSection>
    </SectionGroup>
  );
};

BsEnIsoLiquidLimitAverageValuesSection = withInjectedProps(BsEnIsoLiquidLimitAverageValuesSection);

export { BsEnIsoLiquidLimitAverageValuesSection };
export default BsEnIsoLiquidLimitAverageValuesSection;
